export const STATUS_ENUM = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  OVERDUE: 'Overdue',
  POLICY_CANCELLED: 'Policy Cancelled',
  SUBMITTED: 'Need Review',
  COMPLETE: 'Complete',
} as const;

export const REASON_ENUM = {
  UNKNOWN: 'Unknown',
  POLICY_BOUND: 'Policy Bound',
  POLICY_RENEWAL: 'Policy Renewal',
  POLICY_CANCELLATION: 'Policy Cancellation',
  POLICY_REINSTATEMENT: 'Policy Reinstatement',
  VEHICLE_ADDITION: 'Vehicle Addition',
  VEHICLE_REMOVAL: 'Vehicle Removal',
  COVERAGE_ADDITION: 'Coverage Addition',
  COVERAGE_REMOVAL: 'Coverage Removal',
  EXPIRATION: 'Expiration',
} as const;
